export default __webpack_public_path__ + "static/media/mario-belo.2dfbdb02.webp";